import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import arCommon from './ar/common.json'
import arAuth from './ar/auth.json'
import arUpload from './ar/upload.json'
import arArchive from './ar/archive.json'
import arErrors from './ar/errors.json'
import arDashboard from './ar/dashboard.json'

import enCommon from './en/common.json'
import enAuth from './en/auth.json'
import enUpload from './en/upload.json'
import enArchive from './en/archive.json'
import enErrors from './en/errors.json'
import enDashboard from './en/dashboard.json'

const resources = {
  ar: {
    common: arCommon,
    auth: arAuth,
    upload: arUpload,
    archive: arArchive,
    errors: arErrors,
    dashboard: arDashboard,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    upload: enUpload,
    archive: enArchive,
    errors: enErrors,
    dashboard: enDashboard,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Remove hardcoded lng to let LanguageDetector handle it
    fallbackLng: 'ar', // Default to Arabic if no preference is found
    defaultNS: 'common',
    ns: ['common', 'auth', 'upload', 'archive', 'errors', 'dashboard'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferredLanguage', // Match the key used in LanguageToggle
    },

    react: {
      useSuspense: false, // Disable suspense for SSR compatibility
    },
  })

export default i18n

// Helper to get current direction
export const getDirection = () => {
  return i18n.language === 'ar' ? 'rtl' : 'ltr'
}

// Helper to format numbers for Arabic
export const formatNumber = (num: number): string => {
  if (i18n.language === 'ar') {
    // Convert to Eastern Arabic numerals
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
    return num.toString().replace(/[0-9]/g, (w) => arabicNumerals[+w])
  }
  return num.toString()
}
